import React from 'react'
import pt from 'prop-types'

const AddPickTop = ({ stroke, width = '21px', height = '21px', fill = '#616161' }) => (
  <svg width={width} height={height} viewBox="0 0 21 21" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="plus" fill={fill}>
        <rect id="bar" x="0.5" y="10" width="20" height="1" rx="0.5" />
        <path
          d="M10.5,0.5 L10.5,0.5 C10.7761424,0.5 11,0.723857625 11,1 L11,20 C11,20.2761424 10.7761424,20.5 10.5,20.5 L10.5,20.5 C10.2238576,20.5 10,20.2761424 10,20 L10,1 C10,0.723857625 10.2238576,0.5 10.5,0.5 Z"
          id="bar"
        />
      </g>
    </g>
  </svg>
)

AddPickTop.propTypes = {
  stroke: pt.string,
  width: pt.string,
  height: pt.string,
  fill: pt.string
}

export default AddPickTop
